import WithLink from "features/common/components/WithLink";
import PrimaryButtonWhiteFreeTheme from "./PrimaryButtonWhiteFreeTheme";

export default WithLink(PrimaryButtonWhiteFreeTheme);
